import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import { CATALOG_CATALOG_INDEX_SET_DATA } from 'rebook/apps/catalog/constants';


export function fetchInitialData() {
  return async (dispatch, getState) => {
    const currentState = getState().catalogIndex;
    dispatch(setSeoMeta());

    if (!currentState.niches) {
      await (dispatch(fetchNiches()));
    }
    // if (!currentState.latestBestAuthors) {
    await (dispatch(fetchBestAuthors()));
    // }
    if (!currentState.bestsellersBookset) {
      await (dispatch(fetchBestsellers()));
    }

    if (!currentState.latestBooksets) {
      await (dispatch(fetchLatestBooksets()));
    }

    if (!currentState.audiobooks) {
      await (dispatch(fetchAudiobooks()));
    }
    if (!currentState.latestBookTags) {
      await (dispatch(fetchBookTags()));
    }
  };
}

export function fetchNiches() {
  return (dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/catalog/niches/';

    return fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          niches: data.objects,
        }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load niche list due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
        // eslint-disable-next-line no-console
        console.error(`failed to load niche list due to server error. ${data}`);
      });
  };
}

export function fetchBookTags() {
  return (dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/tags/?limit=10&o=popular';

    return fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          latestBookTags: {
            bookTags: data.objects,
            totalCount: data.meta.total_count,
          },
        }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load niche list due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
        // eslint-disable-next-line no-console
        console.error(`failed to load niche list due to server error. ${data}`);
      });
  };
}

export function fetchBestsellers() {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/booksets/1100/?booklimit=10`;

    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          bestsellersBookset: data,
        }));
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to load bestsellers booksets due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
          },
        });
      });
  };
}

export function fetchBestAuthors() {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/authors/?o=popular&limit=10`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          latestBestAuthors: {
            bestAuthors: data.objects,
            totalCount: data.meta.total_count,
          },
        }));
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to load best authors due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
          },
        });
      });
  };
}

export function fetchLatestBooksets() {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/booksets/?limit=10&booklimit=0`;

    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(fetchBooksetsCount(data.objects));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load latest booksets list due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
      });
  };
}

function fetchBooksetsCount(booksets) {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/booksets/';

    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          latestBooksets: {
            booksets,
            totalCount: data.meta.total_count,
          },
        }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load booksets count due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
      });
  };
}

function fetchAudiobooks() {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/booksets/7302/?booklimit=20';

    return fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          audiobooks: data.books,
        }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load audiobooks due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
      });
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { booksPerSubscriptionCounter } = getState();
    const title = `Читайте и слушайте книги онлайн бесплатно ` +
      `(более ${booksPerSubscriptionCounter.free} бесплатных электронных книг). ` +
      `Простая регистрация в библиотеке MyBook`;
    const description = `В онлайн библиотеке MyBook доступно ${booksPerSubscriptionCounter.total} ` +
      `электронных и аудиокниг. ` +
      `Регистрируйтесь, читайте и слушайте ` +
      `бесплатно более ${booksPerSubscriptionCounter.free} книг. ` +
      `Лучшие книги, новинки, любимые авторы, подборки и аудиоверсии книг ` +
      `по доступной подписке.`;

    const canonicalUrl = `https://${BASE_HOST}/catalog/`;
    dispatch(SeoActions.setData({
      canonicalUrl,
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return {
    type: CATALOG_CATALOG_INDEX_SET_DATA,
    payload,
  };
}
